<template>
    <div class="esv">
        <!-- <v-app-bar fixed floating dense>
        <template v-slot:extension> -->
        <v-tabs v-model="activeTab" @change="handleTabChange" center-active class="fix-position"
            background-color="grey lighten-4">
            <v-tab v-for="tab in availableTabs" :key="tab.key">{{ tab.title }}</v-tab>
        </v-tabs>
        <!-- </template>
</v-app-bar> -->
        <!-- <div class="text-h6">{{ esv.esvReference }}</div> -->

        <v-tabs-items v-model="currentTab" class="mt-12" touchless>
            <v-tab-item eager>
                <Details ref="details" :id="id" :readonly="readonly" @edit="editOrBack" :lockLoading="lockLoading"
                    @save-successful="promptStayInEdit" @save-successful-tab-change="() => {}" :saveCounter="saveCounter" :tabChangeSaveCounter="tabChangeSaveCounter" :reload-counter="reloadCounter" 
                    :isConfirmingTabChange="isConfirmingTabChange" @reload-requested="handleReloadRequest" />
            </v-tab-item>
            <v-tab-item v-if="!$common.isRns(esv)">
                <ExecutionFollowUp :esvId="id" :readonly="readonly" @edit="editOrBack" :lockLoading="lockLoading"
                    @save-successful="promptStayInEdit" @save-successful-tab-change="() => {}" :saveCounter="saveCounter" :tabChangeSaveCounter="tabChangeSaveCounter" :reload-counter="reloadCounter" 
                    :isConfirmingTabChange="isConfirmingTabChange"
                    :edit-mode-exit-message="'<strong>Editing Mode:</strong> This document is locked for you. Please use <strong>Finish Editing</strong> below to finish and release the lock for others.'" />
            </v-tab-item>
            <v-tab-item>
                <InternalDocuments :id="id" :readonly="readonly" @edit="editOrBack" :lockLoading="lockLoading"
                    @save-successful="promptStayInEdit" @save-successful-tab-change="() => {}" :saveCounter="saveCounter" :tabChangeSaveCounter="tabChangeSaveCounter" :reload-counter="reloadCounter" 
                    :isConfirmingTabChange="isConfirmingTabChange" />
            </v-tab-item>
            <v-tab-item>
                <ESVSituation :esvId="id" :readonly="readonly" @edit="editOrBack" :lockLoading="lockLoading"
                    @save-successful="promptStayInEdit" @save-successful-tab-change="() => {}" :saveCounter="saveCounter" :tabChangeSaveCounter="tabChangeSaveCounter" :reload-counter="reloadCounter" 
                    :isConfirmingTabChange="isConfirmingTabChange" />
            </v-tab-item>
        </v-tabs-items>

        <!-- <confirmation-dialog :dialog="confirmationDialog" @confirm="confirm" >
        <template #title>Save changes</template>
        <template #body>
            <v-icon x-large left color="warning">mdi-alert-circle-outline</v-icon>
            <span>Please make sure to save before proceeding</span>
        </template>
    </confirmation-dialog> -->
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: "ESV",
    components: {
        Details: () => import("@/components/ESV/Details"),
        InternalDocuments: () => import("@/components/ESV/InternalDocuments"),
        ExecutionFollowUp: () => import("@/components/ESV/ExecutionFollowUp"),
        ESVSituation: () => import("@/components/ESV/ESVSituation"),
        //   ConfirmationDialog: () => import('@/components/common/ConfirmationDialog.vue')
    },
    props: {
        tab: Number,
        esvId: [Number, String],
        edit: Boolean,
    },
    data() {
        return {
            esv: {},
            activeTab: this.tab, // this.tabProp ? parseInt(this.tabProp) : null,
            currentTab: this.tab,
            tabs: [
                {
                    title: "Details",
                    key: 0,
                    meta: { action: "Read", subject: "ESV", field: "details" },
                },
                {
                    title: "Execution follow up",
                    key: 1,
                    meta: { action: "Read", subject: "ESV", field: "executionFollowUp" },
                },
                {
                    title: "Internal documents",
                    key: 2,
                    meta: { action: "Read", subject: "ESV", field: "internalDocuments" },
                },
                {
                    title: "Situation",
                    key: 3,
                    meta: { action: "Read", subject: "ESV", field: "situation" },
                },
            ],
            readonly: !this.edit,
            isConfirmingTabChange: false,
            confirmationDialog: false,
            lockLoading: false,

            saveCounter: 0,
            tabChangeSaveCounter: 0,
            reloadCounter: 0,
            isPromptingStayInEdit: false,
        };
    },
    mounted() {
        this.getEsv();
    },
    methods: {
        getEsv() {
            this.$api
            .getEsvMinimal(this.esvId)
            .then((resp) => (this.esv = resp.data));
        },
        async editOrBack() {
            this.lockLoading = true;
            if (!this.readonly) {
                // Switching FROM edit mode TO readonly mode - reload to get fresh data
                this.$api
                    .releaseLock(this.id)
                    .then(() => (this.readonly = true))
                    .finally(() => {
                        this.lockLoading = false;
                        this.reloadCounter++;
                    });
            } else {
                if (this.currentTab !== 0) { //Details tab already prepares, here preventing double preparation
                    if (this.$refs.details?.prepareForEditMode) {
                        try {
                            await this.$refs.details.prepareForEditMode();
                        } catch (error) {
                            console.error('❌ EDIT FLOW: Error preparing details for edit mode:', error);
                        }
                    } else {
                        console.error('❌ EDIT FLOW: Details component is unavailable for edit mode preparation.');
                    }
                }

                // Switching FROM readonly mode TO edit mode - don't reload to preserve processed content
                this.$api
                    .lock(this.id)
                    .then(() => {
                        this.readonly = false;
                    })
                    .catch((error) => {
                        console.log(`LockedById is ${error.response.data.lockedById}`);
                        console.log(`User is ${this.$store.state.user.name}`);

                        this.readonly = true;

                        if (error.response.data.lockedById == this.$store.state.user.name) {
                            this.$confirm(
                                "<p><strong>Save changes</strong></p><p>Locked by you in another session? Grab lock here and ignore all pending edits in other session?</p>"
                            ).then((resp) => {
                                if (resp)  {
                                    this.$api
                                    .lock(this.id, true)
                                    .then(() => (this.readonly = false))   
                                }                                                                 
                            });
                        }                 
                    })
                    .finally(() => {
                        this.lockLoading = false;
                        // Don't increment reloadCounter when switching to edit mode
                        // This prevents overwriting processed blob URLs
                    });
            }
        },

        handleTabChange() {
            if (!this.readonly) {
                this.isConfirmingTabChange = true;
            }
            this.processTabChangeConfirmation();
        },

        processTabChangeConfirmation() {
            if (!this.readonly && !this.edit && this.currentTab !== 1) { 
                this.$confirm(
                    "<p><strongSave changes</strong></p><p>Do you want to save and proceed?</p><p>Continue?</p>"
                ).then((resp) => {
                    if (resp) {
                        this.currentTab = this.activeTab;
                        this.tabChangeSaveCounter++;
                    } else {
                        this.activeTab = this.currentTab;
                    }
                }).finally(() => {
                    // Use nested nextTick to reset the flag.
                    // This ensures the flag is reset *after* two DOM update cycles.
                    // Necessary because heavy child components (esp. Details.vue on first load
                    // with CKEditor/image processing) can block the main thread during the first
                    // DOM update, preventing the TabHeader banner's fade-in transition
                    // from starting smoothly. The second tick provides extra buffer time.
                    this.$nextTick(() => { 
                        this.$nextTick(() => {
                            this.isConfirmingTabChange = false;
                        });
                    });
                });
            } else {
                this.currentTab = this.activeTab;
                // Use nested nextTick - see explanation in the finally() block above.
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.isConfirmingTabChange = false;
                    });
                });
            }
        },

        promptStayInEdit() {
          // Prevent dialog from showing if it's already active
          if (this.isPromptingStayInEdit) {
            return;
          }

          // Don't prompt if not in edit mode (safety check)
          if (this.readonly) return;
          
          // Additional safeguard: don't show if we're in the middle of tab change confirmation
          if (this.isConfirmingTabChange) {
            return;
          }
          
          // Set flag to true *before* showing the async dialog
          this.isPromptingStayInEdit = true;

          this.$confirm(
            '<p><strong>Save Successful</strong></p><p>The document is saved but remains locked by you.</p><p>Do you want to continue editing?</p>',
            {
              title: 'Continue Editing?',
              buttonTrueText: 'Yes, Keep Editing',
              buttonFalseText: 'No, Exit and Unlock',
              color: 'primary',
              width: 500
            }
          ).then(stayEditing => {
            if (!stayEditing) {
              this.editOrBack(); // Call method to release lock and set readonly = true
            }
            // If stayEditing is true, do nothing, remain in edit mode.
          }).finally(() => {
            // IMPORTANT: Reset flag after dialog is closed
            this.isPromptingStayInEdit = false;
          });
        },

        handleReloadRequest() {
          this.reloadCounter++;
        }
    },
    computed: {
        id() {
            return parseInt(this.esvId);
        },
        availableTabs() {
            return this.tabs.filter((t) => {
                const canAccess = this.$can(t.meta.action, t.meta.subject, t.meta.field);
                if (t.key === 1 && this.esv.serviceRequestTypeId === 24) {
                    return false;
                }
                return canAccess;
            });
        },
    },
    //   watch: {
    //       activeTab: {
    //           handler() {
    //               if (!this.readonly){
    //                 //   this.confirmationDialog = true;
    //                   this.$confirm('<p><strong>Please make sure to save before proceeding</strong></p><p>Continue?</p>')
    //                     .then(resp => {
    //                         if (resp) {
    //                             this.appliedModelsDatatable.editDialog = true;
    //                         }
    //                     })
    //               }
    //           }
    //       }
    //   }
};
</script>

<style scoped>
.fix-position {
    top: 65px;
    position: fixed;
    z-index: 3;
}
</style>
